import { StepPlaceholder } from '../../../StepPlaceholder/StepPlaceholder';

export const UploadBankEvidencePage = () => {
    return <StepPlaceholder />;
};
